import { defineStore } from "pinia"

export const useNavigationStore = defineStore("navigationStore", {
  state: () => ({
    navigationData: [
      {
        title: "صفحه اصلی",
        icon: { icon: "tabler-user" },
        to: "index",
      },
    ],
    previousRoute: null,
    companyId: null,
  }),
  actions: {
    setNavigationData(items) {
      this.navigationData = items
    },
    setHistoryStack(path) {
      this.previousRoute = path
    },
    setCompanyId(value) {
      this.companyId = value
    },
  },
})
